import { queryClient } from "@/queryClient"

export const deleteRole = async (roleId: string) => {
  await api.delete(`/users/roles/${roleId}/`)

  queryClient.invalidateQueries({
    queryKey: [ROLES_QUERY_KEY],
  })

  queryClient.invalidateQueries({
    queryKey: [USERS_QUERY_KEY],
  })
}
